import React from "react";
import PropTypes from "prop-types";
import styles from "./MediaSectionElement.module.css";
import { IconPlay } from "@wwg/icons";

import classNames from "classnames";
import { PureMediaModal } from "../MediaModal/MediaModal";

/**
 * Interactive component. Displays a video or plays audio for a feed item section.
 */

export function MediaSectionElement({
  isModalOpen,
  setIsModalOpen,
  mediaSettings,
}) {
  const ms = mediaSettings || {};
  const colorValue =
    typeof ms.headerColor === "string"
      ? ms.headerColor.split(" ").slice(1).join(" ") || "#000"
      : "#000";
  const buttonColorValue =
    typeof ms.buttonColor === "string"
      ? ms.buttonColor.split(" ").slice(1).join(" ") || "#000"
      : "#000";
  const buttonHoverColor =
    ms.buttonColor === "default" ? "#728C9F" : ms.buttonColor || "#728C9F";

  const handleMediaOpen = () => {
    if (!ms.id) {
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <section>
      <div className={styles.container}>
        <p style={{ color: colorValue }} className={styles.header}>
          {ms.header}
        </p>
        <button
          type="button"
          style={{ color: buttonColorValue, "--hover-color": buttonHoverColor }}
          className={classNames(styles.button, {
            [styles.hover]: !Object.prototype.hasOwnProperty.call(
              ms,
              "buttonColor"
            ),
          })}
          onClick={handleMediaOpen}
        >
          <IconPlay />
        </button>
      </div>

      <PureMediaModal
        toggleMediaPlayer={() => setIsModalOpen(false)}
        showMediaPlayer={isModalOpen}
        playingMedia={{
          toolType: ms.format === "Audio" ? 15 : 16,
          playerPath: `https://view.vzaar.com/${ms.id || ""}/player`,
        }}
      />
    </section>
  );
}

MediaSectionElement.propTypes = {
  mediaSettings: PropTypes.shape({
    header: PropTypes.string,
    headerColor: PropTypes.string,
    id: PropTypes.string,
    format: PropTypes.oneOf(["Audio", "Video"]),
    buttonColor: PropTypes.string,
  }),

  isModalOpen: PropTypes.bool,
  setIsModalOpen: PropTypes.func,
};
